import type * as ReplaceSubscription from '@ori-events/replace-subscription';
import * as ReplaceSubscriptionFailed from '@ori-events/replace-subscription-failed';
import type { PositionData } from '@ori/analytics-data';
import { HttpMethod } from '@ori/checkout-utils';
import { type GlobalCustomersSubscriptionItemDto } from '@ori/global-api-client-react';

import { replaceSubscription } from '../api';
import { mainLogger } from '../logger';
import { RequestUrl } from '../types';
import type { HandlerSettings } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';

type Data = PositionData & ReplaceSubscription.Data;
type Response = ReplaceSubscriptionFailed.ReplaceSubscriptionResponse;

export async function replaceSubscriptionHandler(
  { detail: { droppingId, itemCode, subscriptionId } }: CustomEvent<Data>,
  { client, customerId, tenant }: HandlerSettings,
) {
  // STEP 1 - Update through API
  const subscriptionItemId = 0;
  const item = {
    droppingId,
    isReplacementAllowed: true,
    itemCode,
    quantity: 1,
    subscriptionItemId,
    // TODO: This was optional / not used before, that's why the cast for now.
    // The ReplaceSubscription event data contains currently only the props destructured above.
    // To change it (if requested), we need cross-team collaboration with Presentation.
    // discountedPrice: 0,
    // discountPercent: 0,
    // totalBp: 0,
    // price: 0,
    // isDropped: false,
  };
  const globalCustomersSubscriptionItemDto = item as GlobalCustomersSubscriptionItemDto;

  try {
    await replaceSubscription({
      client,
      customerId,
      globalCustomersSubscriptionItemDto,
      subscriptionId,
      subscriptionItemId,
      tenant,
    });
  } catch (error: unknown) {
    mainLogger.error(error as Error, { message: 'Error while replacing subscription in replaceSubscription event.' });

    return false;
  }

  // STEP 2 - Update shopping context via Online endpoint
  const response = await fetch(RequestUrl.GetShoppingContext, getHttpRequestSettings(undefined, HttpMethod.Post));
  const data = convertToCamelCase<Response>((await response.json()) as object);

  if (ReplaceSubscriptionFailed.isReplaceSubscriptionErrorResponse(data)) {
    const errorEvent = new CustomEvent<ReplaceSubscriptionFailed.Data>(ReplaceSubscriptionFailed.Name, {
      detail: data,
    });
    window.dispatchEvent(errorEvent);

    return false;
  }

  return data;
}
